import styled from "styled-components";

const AppleWrapper = styled.svg`
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }
`;

const AppleOutline = styled.g``;

const IconWrapper = styled.span`
  box-sizing: border-box;
  display: inline-block;
  line-height: 0;
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }

  * {
    box-sizing: border-box;
  }
`;

export { AppleOutline, AppleWrapper, IconWrapper };
